import { useState } from 'react';

export default function useGroupMembers(
	getGroupMembersQuery: any,
	customSkip?: number,
) {
	const [page, setPage] = useState(1);
	const getGroupMembers = (filter: any) => {
		const skip = customSkip ?? 20;
		getGroupMembersQuery({
			...filter,
			pagination: {
				...filter.pagination,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getGroupMembers, getNextPage, page, setPage };
}
